import * as io from 'io-ts';
import { nullableString } from '@shared/core/types/common';

const rootDefinition: io.MixedObject<OLO.Config.Images> = {
    defaultLocationThumb: nullableString,
};

export const imagesSchema = io.type(rootDefinition);
